import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { ReferenceDataGeneralList, type ReferenceInboxColumn } from '../ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { useStoreCategories, type StoreCategory } from './useData';

function formatAmount(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '';
  const n = typeof v === 'number' ? v : Number(v);
  if (!Number.isFinite(n)) return '';
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(n);
}

const List: React.FC = () => {
  const formatDate = moduleConfig.utils.formatDate;
  const columns = useMemo<ReferenceInboxColumn<StoreCategory>[]>(
    () => [
      {
        key: 'name',
        header: 'Name',
        render: (row) => <span className="font-medium">{row.name}</span>,
      },
      {
        key: 'abrv',
        header: 'Abrv',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => row.abrv || '',
      },
      {
        key: 'isEnableAprv',
        header: 'Approval',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.isEnableAprv ? 'success' : 'secondary'}>
            {row.isEnableAprv ? 'Yes' : 'No'}
          </Badge>
        ),
      },
      {
        key: 'aprvAmnt',
        header: 'Amount limit',
        className: 'hidden whitespace-nowrap md:table-cell',
        render: (row) => formatAmount(row.aprvAmnt),
      },
      {
        key: 'createdAt',
        header: 'Created',
        className: 'hidden whitespace-nowrap lg:table-cell',
        render: (row) => formatDate(row.createdAt),
      },
    ],
    [formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useStoreCategories}
      columns={columns}
      defaultSort={{ key: 'name', direction: 'asc' }}
      newLabel="New category"
      getRowLabel={(row) => row.name}
      activeTabs={false}
    />
  );
};

export default List;
